import { DataBaseModelInterface } from '@solcre-org/core';
import { PortTariffLineModel } from './port-tariff-line.model';
import { PortModel } from './port.model';
import { portUriTemplate } from '../templates/portUriTemplate';

export class PortTariffModel implements DataBaseModelInterface {
  public portDetails?: PortModel;
  public lines?: PortTariffLineModel[];

  constructor(
    public id?: any,
    public port?: string,
    public portId?: any,
    public portCode?: string,
    public portName?: string,
    public terminal?: string | null,
    public berthingType?: string,
    public isActive: boolean = true,
    public archivedAt?: string | null,
    public archivedById?: any,
    public archiveReason?: string | null,
    public createdAt?: string,
    public updatedAt?: string
  ) {}

  public fromJSON(json: any): PortTariffModel {
    if (json) {
      this.id = json.id;
      this.port = json.port;
      this.portId = json.portId ?? json.port?.id ?? this.portId;
      this.portCode = json.portCode ?? json.port?.portCode;
      this.portName = json.portName ?? json.port?.fullName;
      this.terminal = json.terminal ?? null;
      this.berthingType = json.berthingType;
      this.isActive = json.isActive ?? true;
      this.archivedAt = json.archivedAt ?? null;
      this.archivedById = json.archivedById;
      this.archiveReason = json.archiveReason ?? null;
      this.createdAt = json.createdAt;
      this.updatedAt = json.updatedAt;

      if (Array.isArray(json.lines)) {
        this.lines = new PortTariffLineModel().fromJSONList(json.lines);
      } else if (Array.isArray(json.items)) {
        this.lines = new PortTariffLineModel().fromJSONList(json.items);
      }

      if (typeof json.port === 'object' && json.port !== null) {
        this.portDetails = new PortModel().fromJSON(json.port);
        this.port = portUriTemplate(this.portDetails.id?.toString());
        this.portId = this.portDetails.id;
        this.portCode = this.portDetails.portCode;
        this.portName = this.portDetails.fullName;
      } else if (json.portDetails) {
        this.portDetails = new PortModel().fromJSON(json.portDetails);
      }
    }

    return this;
  }

  public fromJSONList(json: any): PortTariffModel[] {
    if (json) {
      return json.map((element: any) => new PortTariffModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      port: this.port,
      portId: this.portId,
      portCode: this.portCode,
      portName: this.portName,
      terminal: this.terminal,
      berthingType: this.berthingType,
      isActive: this.isActive,
      archivedAt: this.archivedAt,
      archivedById: this.archivedById,
      archiveReason: this.archiveReason,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      lines: this.lines?.map((line) => line.toJSON()),
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.berthingType ?? this.id ?? '';
  }
}
